import React from 'react'
import { Box, Text, TextArea } from '@usap/uicomponents'
import { Heading5 } from '../../../../common/heading'
import useWmoEnabled from '@usap/carparts/src/shared/hooks/useWmoEnabled'
import CommentTextAreaWMO from './CommentTextAreaWMO'

const CommentTextArea = props => {
  const {
    widgets,
    isDesktop,
    errorSteps,
    removedReqSel,
    reqElem,
    setReqElem,
    selectedPart,
    commentValueRef,
  } = props

  const requiredData = widgets.required
    ? ''
    : ' <em style="font-size: 12px;font-weight: normal">(Optional)</em>'

  const headerText = `${widgets.title}${requiredData}`

  const isWmoEnabled = useWmoEnabled()

  const isDoesNotExist = wids => {
    const arrElem = reqElem.filter(elem => elem.id === wids)
    if (arrElem.length) {
      return false
    }
    return true
  }

  const handleChange = event => {
    const commentValue = event.target.value
    if (commentValue.trim().length) {
      removedReqSel('comment')
    } else if (isDoesNotExist('comment') && widgets.required) {
      setReqElem([...reqElem, { id: 'comment', type: 'textarea' }])
    }
  }

  if(isWmoEnabled) {
    return (<CommentTextAreaWMO
      {...props}
      handleChange={handleChange}
    />)
  }

  return (
    <Box margin={{ bottom: '24px' }}>
      <Heading5
        width="large"
        title={headerText}
        size={isDesktop ? 'medium' : 'small'}
        color="#000"
        style={{ fontSize: '14px', fontWeight: 700, maxWidth: '100%' }}
        margin={{ bottom: '8px' }}
      />

      {widgets.subtitle && (
        <Box alignContent="start" alignSelf="start" margin="8px 0">
          <Text size="small" margin={{ left: 'xsmall' }}>
            {widgets.subtitle}
          </Text>
        </Box>
      )}

      <Text id={`error-${widgets.id}`} style={{ color: '#f90000', fontSize: '12px' }}>
        {errorSteps[widgets.id]}
      </Text>

      <Box
        direction="column"
        alignContent="start"
        alignSelf="start"
        margin={{ horizontal: 'small', vertical: '0' }}
      >
        <Box height="72px" round="xsmall">
          <TextArea
            fill
            id={`txt${selectedPart}`}
            name="message"
            overflow="auto"
            placeholder="Type here..."
            cols={
              widgets.props[1].id === 'max'
                ? widgets.props[1].value
                : widgets.props[0].value
            }
            rows={
              widgets.props[1].id === 'min'
                ? widgets.props[1].value
                : widgets.props[0].value
            }
            style={{ fontSize: '14px', fontWeight: 'normal', resize: 'none' }}
            onChange={handleChange}
            ref={commentValueRef}
          />
        </Box>
      </Box>
    </Box>
  )
}

export default CommentTextArea
